import * as Sentry from '@sentry/react';

const isDev = import.meta.env.MODE !== 'production';

const messageOf = value =>
	typeof value === 'string' ? value : value?.message ?? 'Non-Error value';

const logger = {
	log(...args) {
		if (isDev) console.log(...args);
	},
	info(...args) {
		if (isDev) console.info(...args);
	},
	warn(message, context = {}) {
		if (isDev)
			console.warn(`⚠️ WARNING IN ${context.location ?? 'unknown location'} —`, message, context);
		else {
			Sentry.addBreadcrumb({
				category: 'log',
				level: 'warning',
				message,
				data: context,
			});
		}
	},
	error(value, context = {}) {
		// Wrapped so the console and Sentry show the message: a plain object prints as {} and Sentry titles it by its keys. `original` keeps its fields.
		const error = value instanceof Error ? value : new Error(messageOf(value));
		const details = error === value ? context : { ...context, original: value };
		if (isDev)
			console.error(`🚨 ERROR IN ${context.location ?? 'unknown location'} —`, error, details);
		else Sentry.captureException(error, { level: 'error', extra: details });
	},
};

export default logger;
